import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classifyStockLevel } from "@shop-ledger/shared-types";
import { FIXED_TOKENS } from "../theme/tokens.js";
const LEVEL_COLOR_VAR = {
    OK: "--sl-color-stock-ok",
    LOW: "--sl-color-stock-low",
    DEPLETED: "--sl-color-stock-depleted",
};
const LEVEL_FALLBACK = {
    OK: FIXED_TOKENS.colorStockOk,
    LOW: FIXED_TOKENS.colorStockLow,
    DEPLETED: FIXED_TOKENS.colorStockDepleted,
};
const LEVEL_TEXT = {
    OK: "In stock",
    LOW: "Low stock",
    DEPLETED: "Out of stock",
};
/**
 * §5's "Automatic visually color-coded stock counters (Green = Good, Orange = Low, Red =
 * Depleted)". Classification logic lives in `@shop-ledger/shared-types`'s
 * `classifyStockLevel` (decimal-safe, shared with any non-UI code that needs the same
 * rule) — this component is purely presentational on top of it.
 */
export function StockIndicator({ currentStock, lowStockThreshold, showLabel = false }) {
    const level = classifyStockLevel(currentStock, lowStockThreshold);
    const colorVar = LEVEL_COLOR_VAR[level];
    const fallback = LEVEL_FALLBACK[level];
    return (_jsxs("span", { className: `sl-stock-indicator sl-stock-indicator--${level.toLowerCase()}`, "data-stock-level": level, role: "status", "aria-label": `${LEVEL_TEXT[level]}${showLabel ? `: ${currentStock}` : ""}`, children: [_jsx("span", { className: "sl-stock-indicator__dot", style: { backgroundColor: `var(${colorVar}, ${fallback})` } }), showLabel ? _jsx("span", { className: "sl-stock-indicator__count", children: currentStock }) : null] }));
}
//# sourceMappingURL=StockIndicator.js.map